import * as React from "react"

const GoldBannerSmall: React.FC = () => {
  return (
    <span className="inline-flex flex-row items-center w-[48px] h-[18px] bg-[#AB8D51] rounded-md gap-x-[2px] py-[2px] px-[4px]">
      <img
        src="/icons/star.svg"
        alt="lotus-gold"
        className="w-[14px] h-[14px]"
      />
      <div className="font-extrabold text-white text-[10px]">Gold</div>
    </span>
  )
}

export default GoldBannerSmall
